import _get from 'lodash/get';

export const Authors = [
  {
    name: 'Sam Jones',
    authorSlug: 'sam-jones',
    isGuest: false,
    profilePic: 'samjones-authorpic.jpeg',
  },
  {
    name: 'Katie Thompson',
    authorSlug: 'katie-thompson',
    isGuest: false,
  },
  {
    name: 'Grant Hughes',
    authorSlug: 'grant-hughes',
    isGuest: false,
  },
  {
    name: 'Todd Nash',
    authorSlug: 'todd-nash',
    isGuest: false,
  },
  {
    name: 'Declan Barry',
    authorSlug: 'declan-barry',
    isGuest: false,
  },
  {
    name: 'Mark Boswell',
    authorSlug: 'mark-boswell',
    isGuest: false,
  },
  {
    name: 'Guest',
    authorSlug: 'guest',
    isGuest: false,
  },
  {
    name: 'Mason Meyers',
    authorSlug: 'mason-meyers',
    isGuest: false,
  },
  {
    name: 'Ryan Easby',
    authorSlug: 'ryan-easby',
    isGuest: false,
  },
  {
    name: 'Ruari Begg',
    authorSlug: 'ruari-begg',
    isGuest: false,
  },
  {
    name: 'Andrew Duncan',
    authorSlug: 'andrew-duncan',
    isGuest: false,
  },
  {
    name: 'Nox',
    authorSlug: 'nox',
    isGuest: true,
  },
  {
    name: 'Previously on Saints Row',
    authorSlug: 'previously-on-saints-row',
    isGuest: true,
  },
  {
    name: 'Kelly McMurdie',
    authorSlug: 'kelly-mc-murdie',
    isGuest: true,
  },
  {
    name: 'Jase Taylor',
    authorSlug: 'jase-taylor',
    isGuest: true,
  },
  {
    name: 'L Greenfield',
    authorSlug: 'l-greenfield',
    isGuest: true,
  },
  {
    name: 'Chris Wootton',
    authorSlug: 'chris-wootton',
    isGuest: true,
  },
  {
    name: 'Dylan Pamintuan',
    authorSlug: 'dylan-pamintuan',
    isGuest: true,
  },
  {
    name: 'Pezh J.',
    authorSlug: 'pezh-j',
    isGuest: true,
  },
  {
    name: 'Charr Davenport',
    authorSlug: 'charr-davenport',
    isGuest: true,
  },
  {
    name: 'Pezh',
    authorSlug: 'pezh',
    isGuest: true,
  },
  {
    name: 'Alana Dunitz',
    authorSlug: 'alana-dunitz',
    isGuest: true,
  },
  {
    name: 'Jonathan Cramp',
    authorSlug: 'jonathan-cramp',
    isGuest: true,
  },
  {
    name: 'Luz Victoria',
    authorSlug: 'luz-victoria',
    isGuest: true,
  },
  {
    name: 'Luke Greenfield',
    authorSlug: 'luke-greenfield',
    isGuest: true,
  },
  {
    name: 'PowerColor',
    authorSlug: 'powercolor',
    isGuest: true,
  },
  {
    name: 'Mike Crewe',
    authorSlug: 'mike-crewe',
    isGuest: true,
  },
  {
    name: 'Erin McAllister',
    authorSlug: 'erin-mc-allister',
    isGuest: true,
  },
  {
    name: 'Neil Hetherington',
    authorSlug: 'neil-hetherington',
    isGuest: true,
  },
  {
    name: 'Mat Bradley-Tschirgi',
    authorSlug: 'mat-bradley-tschirgi',
    isGuest: true,
  },
  {
    name: 'Glen Kitson - Total War: Warhammer III Wiki Administrator',
    authorSlug: 'glen-kitson-total-war-warhammer-iii-wiki-administrator',
    isGuest: true,
  },
];

/**
 * Retrieve author data for a passed in author slug
 * @param  {String} authorSlug author slug to find data for
 * @return {Object}
 */
export const getAuthorBySlug = authorSlug => Authors.find(a => a.authorSlug === authorSlug);

/**
 * Retrieve author data for a passed in author name
 * @param  {String} authorName author slug to find data for
 * @return {Object}
 */
export const getAuthorByName = authorName => Authors.find(a => _get(a, 'name', '').toLowerCase() === authorName.toLowerCase());


/**
 * Retrieve author name for a passed in slug
 * @param  {String} authorSlug author slug to find name for
 * @return {String}
 */
export const getAuthorNameBySlug = authorSlug => _get(Authors.find(a => a.authorSlug === authorSlug), 'name', '');
/**
 * Retrieve author slug for a passed in author name
 * @param  {String} authorName author name to find slug for
 * @return {String}
 */
export const getAuthorSlugByName = authorName => _get(Authors.find(a => a.name === authorName), 'authorSlug', '');
